// extracted by mini-css-extract-plugin
export default {"Container":"Audit_Container__nPrPl","content":"Audit_content__rKLTg","section-1":"Audit_section-1__gtfrR","section-2":"Audit_section-2__+liWM"};